import { CSSProperties } from 'react';

import { ApiStatuses } from 'coreOld/enums';
import { Icon, LoaderSpinner } from 'coreOld/elements';
import { useNotification } from 'coreOld/hooks/useNotification';

import { closeIconStyle, iconStyle, Message, spinnerStyle, Wrapper } from './topNotificationStyle';

interface IProps {
  message: string | JSX.Element;
  style?: CSSProperties;
  showNotification?: boolean;
  type: ApiStatuses;
}

export const NOTIFICATION_ICON = {
  [ApiStatuses.SUCCESS]: <Icon name={Icon.SUCCESS} style={iconStyle} />,
  [ApiStatuses.ERROR]: <Icon name={Icon.EXCLAMATION} style={iconStyle} />,
  [ApiStatuses.LOADING]: <LoaderSpinner style={spinnerStyle} />,
  [ApiStatuses.INFO]: <Icon name={Icon.INFO} style={iconStyle} />,
  [ApiStatuses.WARNING]: <Icon name={Icon.INFO} style={iconStyle} />,
};

const TopNotificationView = ({ message, style, showNotification, type }: IProps) => {
  const { clearNotification } = useNotification();

  return (
    <Wrapper style={style} showNotification={showNotification} type={type}>
      <Message>
        {NOTIFICATION_ICON[type]}
        {message}
      </Message>

      <Icon name={Icon.CLOSE} style={closeIconStyle} onClick={clearNotification} />
    </Wrapper>
  );
};

export default TopNotificationView;
